import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CanvasComponent } from './canvas/canvas.component';
import { HomeComponent } from './home/home.component';
import { AboutMeComponent } from './aboutMe/aboutMe.component';
import { ExperienceComponent } from './experience/experience.component';
import { ProjectsComponent } from './projects/projects.component';
import { GalleryComponent } from './gallery/gallery.component';
import { ContactComponent } from './contact/contact.component';
import { SkillsComponent } from './skills/skills.component';
import { ClientsComponent } from './clients/clients.component';

@NgModule({
  declarations: [
    HomeComponent,
    AboutMeComponent,
    CanvasComponent,
    ExperienceComponent,
    ProjectsComponent,
    GalleryComponent,
    ContactComponent,
    SkillsComponent,
    ClientsComponent
  ],
  imports: [CommonModule, FormsModule, RouterModule],
  exports: [
    HomeComponent,
    AboutMeComponent,
    CanvasComponent,
    ExperienceComponent,
    ProjectsComponent,
    GalleryComponent,
    ContactComponent,
    SkillsComponent,
    ClientsComponent
  ],
})
export class PagesModule {}
